import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export default function formatTimeToAmPm(time: string): string {
  return dayjs(time, 'HH:mm').format('h:mma');
}
